import { render, staticRenderFns } from "./TelFindPwd.vue?vue&type=template&id=6f20f136"
import script from "./TelFindPwd.vue?vue&type=script&lang=js"
export * from "./TelFindPwd.vue?vue&type=script&lang=js"
import style0 from "./TelFindPwd.vue?vue&type=style&index=0&id=6f20f136&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports